import type { EvidenceSection } from '@api/brokerCases/types';
import { EvidencePage } from './EvidencePage';

interface EvidenceTabContentProps {
  caseId: string;
  sections: EvidenceSection[];
  isCaseTasksLoading: boolean;
  isEmbedded?: boolean;
}

export const EvidenceTabContent = ({
  caseId,
  sections,
  isCaseTasksLoading,
  isEmbedded = false,
}: EvidenceTabContentProps) => {
  return (
    <div className='mt-6'>
      <EvidencePage
        caseId={caseId}
        sections={sections}
        isCaseTasksLoading={isCaseTasksLoading}
        isEmbedded={isEmbedded}
      />
    </div>
  );
};
